import React from 'react';
import { ErrorRequestState } from '../../models/RequestState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getErrorObject } from '../../models/ErrorObject';
import {useTranslation} from 'react-i18next';

interface CoreApiErrorProps {
    requestState: ErrorRequestState,
}

const CoreApiError: React.FC<CoreApiErrorProps> = (props) => {
    const {t} = useTranslation(['common'])

    const getErrorMessage = (requestState: ErrorRequestState) => {
        if (requestState.error.response?.status === 403) {
            return t('httpStatus.403', {ns: 'common'})        }
        
        const errorObject = getErrorObject(requestState)
        return t(`errorObjectDescription.${errorObject.error}`, {defaultValue: errorObject.description, ns: 'common'})
        
    }
    var message = getErrorMessage(props.requestState);
    return <><FontAwesomeIcon title="ERROR" color="red" icon={['fas', 'triangle-exclamation']} /> {message}</>
}

export default CoreApiError;
